import { render, staticRenderFns } from "./voice_share.vue?vue&type=template&id=259f1f77&"
import script from "./voice_share.vue?vue&type=script&lang=js&"
export * from "./voice_share.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports